/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Auth_TypeInputs */

const cs_form_auth_type = /** @type {(inputs: Form_Auth_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ autentizace`)
};

const en_form_auth_type = /** @type {(inputs: Form_Auth_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth type`)
};

/**
* | output |
* | --- |
* | "Auth type" |
*
* @param {Form_Auth_TypeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_auth_type = /** @type {((inputs?: Form_Auth_TypeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Auth_TypeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_auth_type(inputs)
	return cs_form_auth_type(inputs)
});